import { render, staticRenderFns } from "./AddLocationModal.vue?vue&type=template&id=6545a63a&"
import script from "./AddLocationModal.vue?vue&type=script&lang=js&"
export * from "./AddLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports